import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    notifications: [],
    directNotifications: [],
    initialized: false,
    loading: false,
    resetInterval: false,
};
export const notificationsSlice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setResetInterval: (state, action) => {
            state.resetInterval = action.payload;
        },
        setNotifications: (state, action) => {
            state.initialized = true;
            state.notifications = action.payload.grouped || [];
            state.directNotifications = action.payload.directNotifications || [];
        },
    },
});
export const { setNotifications, setLoading, setResetInterval } = notificationsSlice.actions;
export default notificationsSlice.reducer;
